<template>
    <page>
        <module :title="id ? '编辑礼包' : '新建礼包'">
            <c-form ref="form">
                <c-form title="">
					<c-form-item type="input" label="礼包名称" name="name" required></c-form-item>
                    <c-form-item type="image" label="礼包海报" name="gift_img_list" limit="5" required
                                 file-word="建议尺寸：宽750像素，高度不限，格式支持：jpg、jpeg、png等，最多上传5张图"></c-form-item>
                    <c-form-item label="选择商品" required>
                        <m-operate>
                            <c-button color="gray" power="b_gift_package_info_edit" hollow sku @click="$refs.productSelector.open()">添加商品</c-button>
                        </m-operate>

                        <c-table ref="productList" v-model="productList" height="300" :paging="false" border>
                            <c-table-column
                                    label="商品名称"
                                    name="product_name"
                                    width="250"
                            ></c-table-column>

                            <c-table-column
                                    label="商品规格"
                                    name="product_sku_spec"
                                    width="100"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="SKU编码"
                                    name="product_sku_code"
                                    width="100"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="日常售价"
                                    name="product_price"
                                    width="50"
                            >
                                <template v-slot="row">
                                    {{'¥'+parseFloat(row.data.product_price).toFixed(2)}}
                                </template>
                            </c-table-column>

                            <c-table-column
                                    required
                                    label="数量"
                                    width="50"
                            >
                                <template v-slot="row">
                                    <c-input width="70" type="number"   v-model="row.data.gift_count" ></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="100"
                            >
                                <template v-slot="row">
                                    <c-table-button power="b_gift_package_info_edit" @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                        <p style="padding: 0 20px;line-height: 40px;font-weight: bold; text-align: right;background: #f5f5f5;">合计：¥{{totalPrice}}</p>
                    </c-form-item>
                    <c-form-item type="editor" label="备注说明" name="remark"  :inline-word="false"></c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button size="m" power="b_gift_package_info_edit" @click="submit()">提交保存</c-button>
            </template>
        </module>

        <product-selector sku ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>

    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'special_price_edit',

        components: {
            productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                productList: []

            }
        },

        computed: {
            ...mapState(['dict']),
            totalPrice(){
                var tmp =0
                this.productList.forEach((item)=>{
                    tmp += (Number.parseFloat(item.product_price) * (item.product_count != undefined && item.product_count != "" ? item.product_count : 1))
                })
                tmp = parseFloat(tmp).toFixed(2);
                return tmp;
            }
        },

        watch: {
            id() {
                this.getDetail();
            }
        },

        mounted() {
            this.id && this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/gift_package/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        console.log("data",JSON.stringify(data))
                        this.$refs.form.set(data);
                        this.productList = data.giftPackageProductList || [];
                    }
                });
            },

            selectHandle(list, ref, key) {
                list = list.filter(item => {
                    return !this[ref].find(row => {
                        return row[key] == item[key];
                    });
                });
                this[ref] = this[ref].concat(list);
            },


            submit(state) {
                this.$refs.form.submit({
                    url: this.id ? '/gift_package/edit' : '/gift_package/add',

                    rule: {
                        name:'请填写礼包名称',
                        gift_img_list: '请上传礼包海报',
                        productList: [{
                            type: 'function',
                            fun: () => {
                                return !!this.productList.length;
                            },
                            word: '请选择商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    return !item.gift_count;
                                });
                            },
                            word: '请设置商品数量'
                        }],

                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.giftPackageRefList = Array.from(this.productList, item => {
                            return {
                                gift_count: Number.parseInt(item.gift_count),
                                gift_id: item.gift_id,
                                sale_price: item.product_price
                            }
                        });
                        return data;
                    },

                    success: () => {
                        this.$message({
                            text: '保存成功'
                        });
                        this.$bus.$emit('giftPackageList.update', {});
                        this.redirectTo('/gift_package_list');
                    }
                })
            },


            productSelectHandle(list) {
                list = list.filter(item => {
					item.gift_id = item.product_sku;
                    return !this.productList.find(row => {
                        return row.gift_id == item.gift_id;
                    });
                });
                this.productList = this.productList.concat(list);
            },


        }
    }
</script>